import type { JournalEntryLine } from '@/services/accounting'

export function lineMissingDepartment(line: JournalEntryLine): boolean {
  return !line.department_id?.trim() && !line.department_name?.trim()
}

/** Fill missing or partial QBO location fields using the store's department mapping. */
export function normalizeCloverJournalLineLocations(
  lines: JournalEntryLine[],
  storeDepartment: Pick<JournalEntryLine, 'department_id' | 'department_name'>,
): JournalEntryLine[] {
  const deptId = storeDepartment.department_id?.trim() || null
  const deptName = storeDepartment.department_name?.trim() || null
  if (!deptId && !deptName) {
    return lines
  }

  return lines.map((line) => {
    const lineId = line.department_id?.trim() || null
    const lineName = line.department_name?.trim() || null

    if (lineId && lineName) {
      return line
    }
    if (lineId && !lineName && deptId === lineId && deptName) {
      return { ...line, department_name: deptName }
    }
    if (!lineId && lineName && deptName === lineName && deptId) {
      return { ...line, department_id: deptId }
    }
    if (lineId || lineName) {
      return line
    }
    return {
      ...line,
      department_id: deptId,
      department_name: deptName,
    }
  })
}
